(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["current-chapter-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('current-chapter-rail')) {
  customElements.define('current-chapter-rail', class CurrentChapterRail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      const viewport = this.querySelector('[data-rail-viewport]');
      const previous = this.querySelector('[data-rail-previous]');
      const next = this.querySelector('[data-rail-next]');
      const card = this.querySelector('[data-rail-card]');
      if (!viewport || !previous || !next || !card) return;
      this.dataset.initialized = 'true';
      const getStep = () => {
        const track = viewport.querySelector('.chapter-rail__track');
        const styles = getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
        return card.getBoundingClientRect().width + gap;
      };
      const updateButtons = () => {
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
      };
      previous.addEventListener('click', () => viewport.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      next.addEventListener('click', () => viewport.scrollBy({ left: getStep(), behavior: 'smooth' }));
      viewport.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initQuote(el) {
    if (prefersReducedMotion) {
      el.classList.add('pt-quote-is-visible');
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('pt-quote-is-visible');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(el);
    } else {
      el.classList.add('pt-quote-is-visible');
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-pt-quote-fade]');
    els.forEach(initQuote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["survival-signal"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('survival-signal')) {
  customElements.define('survival-signal', class SurvivalSignal extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ss-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-ss-panel]'));
      if (!this.tabs.length || !this.panels.length) return;

      var self = this;

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.activate(Number(tab.getAttribute('data-index')));
        });
        tab.addEventListener('keydown', function (event) {
          var currentIndex = Number(tab.getAttribute('data-index'));
          var nextIndex = null;

          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % self.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + self.tabs.length) % self.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = self.tabs.length - 1;

          if (nextIndex !== null) {
            event.preventDefault();
            self.activate(nextIndex);
            self.tabs[nextIndex].focus();
          }
        });
      });
    }

    activate(index) {
      this.tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      this.panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-we-exist"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  function initSection(el) {
    if (prefersReducedMotion) {
      el.classList.add('wwe-is-visible');
      return;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('wwe-is-visible');
              observer.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(el);
    } else {
      el.classList.add('wwe-is-visible');
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-wwe-fade]');
    els.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
